import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import "../css/Refer.css";

import io from "../Components/socket";
import Socket from "./../Components/socket";

const Refer = ({ user }) => {
  const addsetting = localStorage.getItem("sitSetting");
  const addCaseSetting = JSON.parse(addsetting);

  const [cardData, setGame] = useState([]);

  const [open, setOpen] = useState(false);

  useEffect(() => {
    io.on("setProfile", (data) => {
      setOpen(data.superUser);
    });
  }, [Socket]);

  useEffect(() => {
    const data = localStorage.getItem("udata");
    const userData = JSON.parse(data);
    setOpen(userData?.superUser);
  }, []);

  const copyCode = (e) => {
    navigator.clipboard.writeText(user.referral_code);

    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referral Code Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  const copyLink = (e) => {
    Swal.fire({
      position: "center",
      icon: "success",
      type: "success",
      title: "Referal Link Copied",
      showConfirmButton: false,
      timer: 1200,
    });
  };

  if (user === undefined) {
    return null;
  }

  const referralText = `🎲 MrLudoHub.com 🎲

Ludo khelo aur real cash jeeto 💰

✅ Instant Withdraw
✅ Safe & Secure
✅ 24x7 Support

Mera Referral Code:
👉 ${user.referral_code}

Join Now:
https://mrludohub.com/login/${user.referral_code}

Aur har game jeet kar kamao real paise! 🚀`;

  return (
    <>
      {/* <Header user={user} /> */}
      <div>
        <div
          className="leftContainer mt-4 pb-5"
          style={{ minHeight: "", height: "100%" }}
        >
          <div className="refer-dashboard" style={{ paddingTop: 40 }}>
            <div className="referHero">
              <div>
                <h2>Invite & Earn</h2>
                <p>Earn 3% commission on every referral winning.</p>
              </div>

              <div className="rewardBadge">₹{user.referral_earning || 0}</div>
            </div>

            <div className="codeCard">
              <div className="codeTitle">YOUR REFERRAL CODE</div>

              <div className="codeBox">
                <span className="codeText">{user.referral_code}</span>

                <button className="copyBtn" onClick={copyCode}>
                  Copy
                </button>
              </div>
            </div>

            <a
              href={`whatsapp://send?text=${encodeURIComponent(referralText)}`}
            >
              <button className="shareBtn">Share on WhatsApp</button>
            </a>

            <div className="statsGrid">
              <div className="statCard">
                <h3>{user.referral_user?.length || 0}</h3>
                <p>Total Referrals</p>
              </div>

              <div className="statCard">
                <h3>₹{user.referral_earning || 0}</h3>
                <p>Total Earnings</p>
              </div>
            </div>

            <div className="howCard">
              <h4>How It Works</h4>

              <div className="step">
                <div className="stepNo">1</div>
                <p>Share your referral code with friends.</p>
              </div>

              <div className="step">
                <div className="stepNo">2</div>
                <p>Friend joins using your code.</p>
              </div>

              <div className="step">
                <div className="stepNo">3</div>
                <p>Earn 3% commission on every winning game.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Refer;
